import { Card, Divider, Typography } from '@healthinal/ui';
import { EditTracingContactContactForm } from './EditTracingContactContactForm.tsx';

export function TracingContactContactCard({ tracingContactId }: { tracingContactId: string }) {
  return (
    <Card>
      <Typography level={'title-lg'}>Kontakt</Typography>
      <Divider />
      <EditTracingContactContactForm tracingContactId={tracingContactId} />
    </Card>
  );
}
